import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const SubscriptionFilter = () => {
  const dispatch = useDispatch();

  const subscriptions = useSelector((state) => state.onDemandRevenue.filters.subscriptions);
  const selectedSubscriptions = useSelector(
    (state) => state.onDemandRevenue.selectedFilters.selectedSubscriptions
  );

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateSubscriptionFilter(data));
  };

  return (
    <MultiSelectDropdown
      options={subscriptions}
      selectedFilters={selectedSubscriptions}
      includeFilter
      enableOnly
      height={324}
      includeSelectAll
      numberDisplayed={0}
      onSelectChange={onSelectChange}
    />
  );
};

export default SubscriptionFilter;
